import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import { sunoCommsApi } from "../api-base";
import type {
  NotificationSetting,
  NotificationSettingCreate,
  NotificationSettingFilter,
  NotificationSettingRule,
  NotificationSettingRuleCreate,
  NotificationSettingRuleFilter,
  NotificationSettingRuleUpdate,
  NotificationSettingUpdate
} from "../types/notification-settings.type";

export const notificationSettingsEndpoints = sunoCommsApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getNotificationSettings: builder.query<
      NotificationSetting[],
      NotificationSettingFilter | void
    >({
      query: (filter = {}) =>
        `/notification-settings/${formatValidQueryParamUrlCommaSeparated(
          filter,
          true
        )}`,
      providesTags: ["NotificationSettings"]
    }),
    createNotificationSetting: builder.mutation<
      NotificationSetting,
      NotificationSettingCreate
    >({
      query: (body) => ({
        url: "/notification-settings/",
        method: "POST",
        body
      }),
      invalidatesTags: ["NotificationSettings"]
    }),
    updateNotificationSetting: builder.mutation<
      NotificationSetting,
      NotificationSettingUpdate & { id: string }
    >({
      query: ({ id, ...body }) => ({
        url: `/notification-settings/${id}`,
        method: "PATCH",
        body
      }),
      invalidatesTags: ["NotificationSettings"]
    }),
    deleteNotificationSetting: builder.mutation<void, string>({
      query: (id) => ({
        url: `/notification-settings/${id}`,
        method: "DELETE"
      }),
      invalidatesTags: ["NotificationSettings"]
    }),

    getNotificationSettingRules: builder.query<
      NotificationSettingRule[],
      NotificationSettingRuleFilter | void
    >({
      query: (filter = {}) =>
        `/notification-setting-rules/${formatValidQueryParamUrlCommaSeparated(
          filter,
          true
        )}`,
      providesTags: ["NotificationSettingRules"]
    }),
    createNotificationSettingRule: builder.mutation<
      NotificationSettingRule,
      NotificationSettingRuleCreate
    >({
      query: (body) => ({
        url: "/notification-setting-rules/",
        method: "POST",
        body
      }),
      invalidatesTags: ["NotificationSettingRules"]
    }),
    updateNotificationSettingRule: builder.mutation<
      NotificationSettingRule,
      NotificationSettingRuleUpdate
    >({
      query: ({ id, ...body }) => ({
        url: `/notification-setting-rules/${id}`,
        method: "PATCH",
        body
      }),
      invalidatesTags: ["NotificationSettingRules"]
    }),
    deleteNotificationSettingRule: builder.mutation<void, string>({
      query: (id) => ({
        url: `/notification-setting-rules/${id}`,
        method: "DELETE"
      }),
      invalidatesTags: ["NotificationSettingRules"]
    })
  })
});

export const {
  useGetNotificationSettingsQuery,
  useCreateNotificationSettingMutation,
  useUpdateNotificationSettingMutation,
  useDeleteNotificationSettingMutation,
  useGetNotificationSettingRulesQuery,
  useCreateNotificationSettingRuleMutation,
  useUpdateNotificationSettingRuleMutation,
  useDeleteNotificationSettingRuleMutation
} = notificationSettingsEndpoints;
